import { Flex } from '@hover/blueprint';
import type { FlexProps } from '@hover/blueprint/chakra';
import React from 'react';

const Header = (props: FlexProps) => (
  <Flex
    direction="column"
    flexGrow={0}
    flexShrink={0}
    order={0}
    px={{ base: 400, tablet: 600 }}
    py={{ base: 100, tablet: 300 }}
    {...props}
  />
);

const Body = (props: FlexProps) => (
  <Flex
    direction="column"
    flexGrow={1}
    flexShrink={1}
    order={1}
    overflow="auto"
    px={{ base: 400, tablet: 600 }}
    py={100}
    {...props}
  />
);

const Footer = (props: FlexProps) => (
  <Flex
    direction="column"
    flexGrow={0}
    flexShrink={0}
    order={2}
    px={{ base: 400, tablet: 600 }}
    py={{ base: 100, tablet: 300 }}
    {...props}
  />
);

const Menu = (props: FlexProps) => (
  <Flex
    direction="column"
    gap={0}
    height="100%"
    p={0}
    width="100%"
    {...props}
  />
);

export const ScrollMenu = {
  Menu,
  Header,
  Body,
  Footer,
};
